import { useRef } from "react";
import { createContext, useContext, useState, useEffect } from "react";
import { useUserStore } from "./useUserStore";     // We rely on user info & token
import SpecificAPI from "../services/SpecificApi";

const UserRightsContext = createContext(null);

export const UserRightsProvider = ({ children }) => {
  const hasLoadedRef = useRef(false);
  const { appUser, isAppUserLoading } = useUserStore();

  const [userRights, setUserRights] = useState({});
  const [isUserRightsLoading, setIsUserRightsLoading] = useState(true);
  const [error, setError] = useState(null);

  const userCanPerform = (module, action, objectId) => {
    return true; // TEMP bypass
  };

  useEffect(() => {
    if (isAppUserLoading) return;

    // 🔁 reset on logout
    if (!appUser) {
      hasLoadedRef.current = false;
      setUserRights({});
      setIsUserRightsLoading(false);
      return;
    }

    // 🛑 fetch once
    if (hasLoadedRef.current) return;
    hasLoadedRef.current = true;

    const loadUserRights = async () => {
      try {
        setIsUserRightsLoading(true);

        const response = await SpecificAPI.getUserRights({
          userId: appUser.id,
        });

        setUserRights(response?.data || {});
      } catch (err) {
        console.error("Failed to load user rights:", err);
        setError(err);
      } finally {
        setIsUserRightsLoading(false);
      }
    };

    loadUserRights();
  }, [appUser, isAppUserLoading]);

  return (
    <UserRightsContext.Provider
      value={{ userRights, isUserRightsLoading, error, userCanPerform }}
    >
      {children}
    </UserRightsContext.Provider>
  );
};


export const useUserRightsStore = () => useContext(UserRightsContext);
